import { cssSafeString } from "@jugl-web/utils/dom";

export const getCustomFieldButtonId = (fieldId: string) =>
  cssSafeString(`custom-field-${fieldId}`);
